import React from "react";
import InputForm from "../../generales/InputForm";
import { capitalizeFirstLetter } from "../../../utils/utils";
import Action from "../../Action";
import { useState ,useEffect} from 'react';
import Modal from "react-modal";
import ModalLinKHost from "../ModalLinKHost";
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
const Step1 = ({hostSelected,setHostSelected,handleChange,cisData,users_catalog,changeOption,editActive,setCisData,server,handleShowPopup,languaje,mode,cisSelectedAux,setPoolRows2}) => {
  const [hostsListSyncModalOpen, setHostsListSyncModalOpen] =useState(false);
  function openHostsListSyncModal() {
  //    setCisSelectedAux(elemento);
      setHostsListSyncModalOpen(true);
    }

  function closHostsListSyncModal() {
    
    setHostsListSyncModalOpen(false);
  }
  useEffect(() => {
    if(editActive){
      setHostSelected({
        host:cisData.description,
        hostid:cisData.hostid,
        agent_ip:cisData.ip,
        alias:cisData.affiliation,
        brand_id:cisData.brand_id,
        location_id:cisData.location_id,
        mac:cisData.mac,
        model_id:cisData.model_id,
        serialno:cisData.serial
      })
    }
  }, [])
  function vincular(){
    setCisData((prevState)=>{
      return {
          ...prevState,
            ['hostid']:hostSelected.hostid,
            ['ip']:hostSelected.agent_ip,
        ['affiliation']:hostSelected.alias,
        ['brand_id']:hostSelected.brand_id,
        ['location_id']:hostSelected.location_id,
        ['mac']:hostSelected.mac,
        ['model_id']:hostSelected.model_id,
        ['serial_no']:hostSelected.serialno,
        
      } 
      
  })
    closHostsListSyncModal()
  }
  function desvincular(){
    setHostSelected({hostid:0})

    setCisData((prevState)=>{
      return {
          ...prevState,
            ['hostid']:0,
            ['ip']:"",
        ['affiliation']:"",
        ['brand_id']:null,
        ['location_id']:null,
        ['mac']:"",
        ['model_id']:null,
        ['serial_no']:"",
        
      } 
      
  })
    closHostsListSyncModal()
  }
  return(
      <>
      <div className="cont-step-modal">
          <div className="compact-step-modal">
               <div className="title-step-modal">
              <div className="txt-title-step-modal">
                   {'INFORMACION PRINCIPAL'}
              </div>               
          </div>
          <div className="body-step-modal">
              <div className={"compact-body-step-modal "}>
                <div className="row-form-modal">
                  <div className="colum-form-modal">
                      <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'name'} titulo={'Nombre'} text={cisData.name} placeHolder={''} disabled={false} isRequired={true}/>
                  </div>
                <div className="colum-form-modal">
                      <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'affiliation'} titulo={'Afiliacion'} text={cisData.affiliation} placeHolder={'Ejemplo: vvu-edo-001'} disabled={false} isRequired={true}/>
                  </div>
                </div>
                
                <div className="row-form-modal">
                  <div className="colum-form-modal">
                      <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'ip'} titulo={'Dispositivo'} text={(hostSelected.hostid!=0)?hostSelected.host:''} placeHolder={'Vinucle un dispositivo'} disabled={true} isRequired={false}/>
                  </div>
                 <div className="colum-form-modal">
        <Action disabled={false} origen={(hostSelected.hostid!=0)?'Red':'Filtro'} titulo={(hostSelected.hostid!=0)?'Desvincular':'Vincular'}  action={()=>(hostSelected.hostid!=0)?desvincular():openHostsListSyncModal()} icon={'vincular'}/>
               </div>
                </div>
                 <div className="row-form-modal">
                  <div className="colum-form-modal">
                      {/* {(users_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>:
                     <InputForm optionDefault={0} type='input' endpoint='Users'msgError={'El Solicitante y Autorizador no pueden ser iguales'}  error={cisData.request_user===cisData.auth_user} changeOption={changeOption}  attr={'request_user'} titulo={'Solicitante'} loading={users_catalog.loading} data={users_catalog.data.data} text={cisData.request_user} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={true}/>
                      } */}
                       <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'request_user'} titulo={'Solicitante'} text={cisData.request_user} placeHolder={''} disabled={false} isRequired={true}/>

                      </div>
                <div className="colum-form-modal">
                      {/* {(users_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>: 
                      <InputForm optionDefault={0} type='selector' endpoint='Users' msgError={'El Solicitante y Autorizador no pueden ser iguales'} error={cisData.request_user===cisData.auth_user} changeOption={changeOption}  attr={'auth_user'} titulo={'Autorizador'} loading={users_catalog.loading} data={users_catalog.data.data} text={cisData.auth_user} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={true}/>
                      } */}
                       <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'auth_user'} titulo={'Autorizador'} text={cisData.auth_user} placeHolder={''} disabled={false} isRequired={true}/>

                  </div>
                </div>
                <div className="row-form-modal-dobel">
                      <InputForm type='textArea'  error={false} handleInputChange={handleChange}  attr={'user_comment'} titulo={'Comentarios'} text={cisData.user_comment} placeHolder={'Agregar comentarios'} disabled={false} isRequired={cisData.user_comment.length<5} coment={'(minimo 5 caracteres)'}/>

                </div>
              </div>
          </div>
      </div>
      </div>      
      <Modal
      isOpen={hostsListSyncModalOpen}
      // isOpen={true}
      // onAfterOpen={afterOpenExeption}
      onRequestClose={closHostsListSyncModal}
      style={hostListModalSyncStyles}
      contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalLinKHost vincular={vincular} desvincular={desvincular} isData={cisData} hostSelected={hostSelected} setHostSelected={setHostSelected} editActive={editActive} setCisData={setCisData}  server={server} handleShowPopup={handleShowPopup}  cisSelectRow={cisSelectedAux} setPoolRows={setPoolRows2} languaje={languaje}  mode={mode} closeAddHostModal={closHostsListSyncModal}   ></ModalLinKHost>
  </Modal>
      </>
  )
}

export default Step1;
 